<template>
  <v-app-bar app absolute color="transparent" flat height="75" style="width: auto;">
    <!-- fullscreen -->
    <v-btn fab small class="ml-0 mr-3">
      <v-icon v-show="expand" @click="toggleFullScreen('expand')">mdi-arrow-expand</v-icon>
      <v-icon v-show="collapse" @click="toggleFullScreen('collapse')">mdi-arrow-collapse</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down mb-0" v-text="$route.meta.title_name"/>
    <!-- Обновить -->
    <div class="mx-3" v-if="isVisibleRefresh">
      <v-btn color="#999" fab small dark>
        <v-icon>mdi-sync</v-icon>
      </v-btn>
    </div>
    <!-- Создать -->
    <!--        <div class="mx-3" v-if="!isVisibleCreate">
                <v-btn color="#999" fab small dark>
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </div>-->
    <!-- Назад -->
    <div class="mx-3" v-if="!isVisibleBack">
      <v-btn color="#999" fab small dark @click="goBack()">
        <v-icon class="reply-btn">reply</v-icon>
      </v-btn>
    </div>
    <!-- ПОИСК -->
    <!--<v-col sm="2" md="2" v-if="!isVisibleSearch">
        <v-text-field
            :label="$t('search')"
            color="secondary"
            hide-details
            class="mb-2"
            style="max-width: 165px;"
        >
            <template v-if="$vuetify.breakpoint.mdAndUP" v-slot:append-outer>
                <v-btn class="mt-n2" fab small>
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
            </template>
        </v-text-field>
    </v-col>-->
    <!-- END ПОИСК -->
    <v-spacer/>

    <!-- Calendar -->


    <v-col class="calendar col-sm-6 col-md-6 col-lg-4" v-if="isVisibleCalendar">
      <v-sheet class="mr-2">
        <v-btn-toggle v-model="period" color="teal" @change="changePeriod">
          <v-btn
            class="period-btn"
            v-for="dir in ['вчера', 'сегодня', 'неделя', 'месяц']"
            :key="dir"
            color="default"
          >{{ dir }}
          </v-btn>
        </v-btn-toggle>
      </v-sheet>

      <template v-slot:after-heading>
        <div class="display-1 mt-2 font-weight-light">
          Date Picker
          <span class="body-1">— labeled</span>
        </div>
      </template>

      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        min-width="290px"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="dateFormatted"
            color="secondary"
            label="Выберите дату"
            prepend-icon="mdi-calendar-outline"
            readonly
            v-on="on"
            class="small-calendar"
          />
        </template>

        <v-date-picker v-model="date" color="secondary" scrollable locale="ru">
          <v-spacer/>
          <v-btn color="secondary" medium @click="menu = false">Отмена</v-btn>

          <v-btn color="secondary" medium @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>


      <date-picker
        v-model="time1"
        valueType="format"
        range
      ></date-picker>


    </v-col>

    <div class="mx-3"/>
    <!-------------- ПЕРЕКЛЮЧЕНИЕ ЯЗЫКА -------------->
    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <img :src="flag_ico.src" :alt="flag_ico.name"/>
        </v-btn>
      </template>

      <v-list>
        <v-list-item key="ua" @click="setFlag('ua')" title="9">
          <v-list-item-title>
            <img src="../../../../assets/img/header/flags/ukraine.png" alt="ua"/>
            <span class="ml-2">Украинский</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item key="ru" @click="setFlag('ru')">
          <v-list-item-title>
            <img src="../../../../assets/img/header/flags/russian.png" alt="ru"/>
            <span class="ml-2">Русский</span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item key="en" @click="setFlag('en')">
          <v-list-item-title>
            <img src="../../../../assets/img/header/flags/english.png" alt="en"/>
            <span class="ml-2">Английский</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- УВЕДОМЛЕНИЯ -->
    <v-menu bottom left offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn min-width="0" text v-bind="attrs" v-on="on">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <span class="caption">5</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <app-bar-item v-for="(n, i) in notifications" :key="`item-${i}`">
            <v-list-item-title v-text="n"/>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from 'vuetify/lib'

// Utilities
import { mapState, mapMutations } from 'vuex'

// DatePicker:
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from "moment";
//import {eventBus} from './../app.js'
import { EventBus } from '../../../../event-bus/event-bus'

export default {
  name: 'DashboardCoreAppBar',

  components: {
    AppBarItem: {
      render (h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default,
              )
            },
          },
        })
      },
    },

    // DatePicker:
    DatePicker,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: vm => ({

    // DatePicker:
    time1: null,

    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    currentRoute: '',
    expand: true,
    collapse: false,
    flag_ico: {
      name: 'ua',
      src: require('../../../../assets/img/header/flags/ukraine.png'),
    },
    // скрыть кнопку "создать +"
    notVisibleCreate: ['ClientBank', 'EditCompany', 'EditUser', 'Invites', 'CallsHistory'],
    // скрыть кнопку "назад ←"
    notVisibleBack: ['ClientBank', 'Companies', 'Users'],
    // показывать календарь
    visibleCalendar: ['CallsHistory_1', 'CallsHistory_2'],
    // скрыть поиск
    notVisibleSearch: ['Invites', 'IpNumbers'],
    notifications: [
      'Mike John Responded to your email',
      'You have 5 new tasks',
      `You're now friends with Andrew`,
      'Another Notification',
      'Another one',
    ],
    label: 'поиск',
    profile: [
      { title: 'Profile' },
      { title: 'Settings' },
      { divider: true },
      { title: 'Log out' },
    ],
    menu: '',

    // выбранный период:
    chPeriod: {
      start_date: '',
      end_date: ''
    },
    // выбор периода
    period: 'week',
  }),

  created () {
    this.currentRoute = this.$route.name
  },

  computed: {
    ...mapState(['drawer']),
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    // Видимость кнопки refresh
    isVisibleRefresh: function () {
      if (this.currentRoute == 'ClientBank') return true
    },
    // Видимость кнопки создать
    isVisibleCreate: function () {
      return this.notVisibleCreate.includes(this.currentRoute)
    },
    // Видимость кнопки назад
    isVisibleBack: function () {
      return this.notVisibleBack.includes(this.currentRoute)
    },
    // Видимость календаря
    isVisibleCalendar: function () {
      return this.visibleCalendar.includes(this.currentRoute)
    },
    // Видимость поиска
    isVisibleSearch: function () {
      return this.notVisibleSearch.includes(this.currentRoute)
      console.log(isVisibleSearch)
    },
  },

  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    },
    $route () {
      this.currentRoute = this.$route.name
      // console.log(this.currentRoute);
    },
  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
    }),

    goBack () {
      this.$router.go(-1)
    },

    setFlag (lang) {
      if (lang == 'en') {
        this.flag_ico.src = require('../../../../assets/img/header/flags/english.png')
        this.flag_ico.name = 'en'
      }
      if (lang == 'ru') {
        this.flag_ico.src = require('../../../../assets/img/header/flags/russian.png')
        this.flag_ico.name = 'ru'
      }
      if (lang == 'ua') {
        this.flag_ico.src = require('../../../../assets/img/header/flags/ukraine.png')
        this.flag_ico.name = 'ua'
      }
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    // Разворот на весь экран
    toggleFullScreen (state) {
      let elem = document.querySelector('html')
      // ## The below if statement seems to work better ## if ((document.fullScreenElement && document.fullScreenElement !== null) || (document.msfullscreenElement && document.msfullscreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      // console.log(state);
      if (
        (document.fullScreenElement !== undefined &&
          document.fullScreenElement === null) ||
        (document.msFullscreenElement !== undefined &&
          document.msFullscreenElement === null) ||
        (document.mozFullScreen !== undefined &&
          !document.mozFullScreen) ||
        (document.webkitIsFullScreen !== undefined &&
          !document.webkitIsFullScreen)
      ) {
        if (elem.requestFullScreen) {
          elem.requestFullScreen()
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullScreen) {
          elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen()
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
      if (state == 'expand') {
        this.collapse = true
        this.expand = false
      } else {
        this.collapse = false
        this.expand = true
      }
    },

    // период
    changePeriod(value) {

      // // this.dialog = true ;
      //this.$emit("changePeriod", value);
      //eventBus.$emit("changePeriod", value);

      //if (value === 'today') {
      if (value == 1) {
        this.chPeriod.start_date = moment();
        this.chPeriod.end_date = moment();
      }

      //if (value === 'yesterday') {
      if (value == 0) {
        this.chPeriod.start_date = moment().subtract(1, 'days');
        this.chPeriod.end_date = moment().subtract(1, 'days');
      }

      //if (value === 'week') {
      if (value == 2) {
        //this.chPeriod.start_date = moment().startOf('week');
        this.chPeriod.start_date = moment().subtract(7, 'days');
        this.chPeriod.end_date = moment();
      }

      //if (value === 'month') {
      if (value == 3) {
        this.chPeriod.start_date = moment().startOf('month');
        this.chPeriod.end_date = moment();
      }

      EventBus.$emit("changePeriod", this.chPeriod);
    },
  },
}
</script>

<style lang="scss">
.reply-btn {
  margin-top: -1px;
}

.calendar {
  display: flex;
  justify-content: flex-end;

  .v-sheet {
    height: 34px;
  }

  .small-calendar {
    max-width: 180px;
  }
}


.calendar-range {
  max-width: 200px;
  min-width: 200px;
}

.mx-datepicker-main {
  border: none !important;
}

.mx-calendar-content {
  .mx-table-date td {
    border-radius: 50%;
    color: black;
  }
}

.mx-calendar-content .cell.in-range {
  color: #434343;
  background-color: #e5e5e5 !important;
}

.mx-datepicker-footer {
  border-top: 0 !important;
}

span.mx-calendar-header-label button,
.mx-calendar-header-label {
  color: #fff;
  font-weight: 600;
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: rgb(45, 121, 189);
}

.mx-calendar + .mx-calendar {
  border-left: 1px solid #ffffff;
}

.mx-datepicker-main.mx-datepicker-popup {
  border-radius: 5px;
}

.mx-calendar-header,
.mx-time-header {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 34px;
  line-height: 34px;
  text-align: center;
  overflow: hidden;
  display: flex;
  height: 50px !important;
  justify-content: space-around;
  align-items: center;
  background: rgb(45, 121, 189);
  border-radius: 5px;
}

button.mx-btn.mx-btn-text {
  color: #fff;
}

// Расположение стрелок
button.mx-btn-icon-double-left {
  order: 1;
}

button.mx-btn-icon-left {
  order: 2;
}

span.mx-calendar-header-label {
  order: 3;
}

button.mx-btn-icon-double-right {
  order: 5;
}

button.mx-btn-icon-right {
  order: 4;
}
</style>
